export class FocusPayPaymentSession {
	amount: Amount;
	countryCode: string;
	expiresAt: string;
	id: string;
	merchantAccount: string;
	reference: string;
	returnUrl: string;
	sessionData: string;

	public constructor(init?: Partial<FocusPayPaymentSession>) {
		Object.assign(this, init);
	}
}

export interface Amount {
	currency: string;
	value: number;
}
